export const FISHINGWATERSGRID_MAX_CATCHES_MOBILE = 10;
export const FISHINGWATERSGRID_MAX_CATCHES_TABLET = 10;
export const FISHINGWATERSGRID_MAX_CATCHES_DESKTOP = 9;
